import { Font, pdf } from '@react-pdf/renderer';

let cairoRegistered = false;
let pdfRenderQueue = Promise.resolve();
let pdfInstance = null;

export const registerCairoFont = () => {
  if (cairoRegistered && Font.getRegisteredFontFamilies?.().includes('Cairo')) return;

  // Keep this as a single regular face. Registering synthetic weights is what
  // makes Arabic textkit resolve to missing glyph/font ids in this app.
  Font.register({
    family: 'Cairo',
    src: `${window.location.origin}/fonts/Cairo.ttf`,
  });
  Font.registerHyphenationCallback(word => [word]);
  cairoRegistered = true;
};

const preparePdfFonts = async () => {
  registerCairoFont();
  await Font.load({
    fontFamily: 'Cairo',
    fontStyle: 'normal',
    fontWeight: 400,
  });
};

const updatePdfContainer = (instance, document) => new Promise((resolve) => {
  instance.updateContainer(document, resolve);
});

export const renderPdfDocumentToBlob = (document) => {
  const renderTask = pdfRenderQueue
    .catch(() => {})
    .then(async () => {
      await preparePdfFonts();

      if (!pdfInstance) {
        pdfInstance = pdf();
      }

      await updatePdfContainer(pdfInstance, document);
      return await pdfInstance.toBlob();
    });

  pdfRenderQueue = renderTask.catch(() => {});
  return renderTask;
};

export const safePdfText = (value, fallback = '-') => {
  if (value === null || value === undefined || value === false) return fallback;

  const text = typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : String(value?.label?.ar || value?.label?.en || value?.name?.ar || value?.name?.en || value?.name || value?.value || fallback);

  return text
    .normalize('NFKC')
    .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g, '')
    .replace(/[\uFE00-\uFE0F\uFEFF]/g, '')
    .replace(/\p{Mark}/gu, '')
    .replace(/[—–]/g, '-')
    .replace(/[•]/g, '-')
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[\u{1F000}-\u{1FAFF}]/gu, '')
    .trim() || fallback;
};
